var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { isFunction } from '../utils';
import { ProgressBarContainer } from '../styles';
export var ProgressBar = function (props) {
    var _a = props.controlledProgress, controlledProgress = _a === void 0 ? false : _a, closeToast = props.closeToast, _b = props.hide, hide = _b === void 0 ? false : _b, className = props.className, userStyle = props.style, isIn = props.isIn, rest = __rest(props, ["controlledProgress", "closeToast", "hide", "className", "style", "isIn"]);
    var classNames = isFunction(className)
        ? className({
            rtl: rest.rtl,
            type: rest.type,
        })
        : className;
    var animationEvent = {
        onAnimationEnd: function () {
            isIn && closeToast();
        },
    };
    return (_jsx(ProgressBarContainer, __assign({ controlledProgress: controlledProgress, isHidden: hide, role: "progressbar", "aria-hidden": hide ? 'true' : 'false', className: classNames, style: userStyle }, rest, animationEvent)));
};
